import { useSelector } from "react-redux";

const Employe = ({
  etablissement,
  selectedEmployee,
  handleEmployeeChange,
  edit = true,
  onEdit,
}) => {
  const { employe } = useSelector((state) => state.rendezvous);
  // console.log({ employe });
  return (
    <>
      {!employe.isEditing && employe?.checked ? (
        <div className="intervention flex-between mt-24">
          <div>
            <h5>Employé demandé</h5>
            <p className="body text-gray-500">
              {employe?.selectedEmploye?.name}
            </p>
          </div>
          {edit && (
            <button onClick={onEdit} className="link-blue">
              {" "}
              Modifier{" "}
              <img src="/images/edit.svg" alt="icon edit" className="ml-8" />
            </button>
          )}
        </div>
      ) : (
        <>
          {" "}
          <h4 className="grey500 mb-0 mt-16">Préférence d'employé</h4>
          <div className="intervention-options d-flex flex-wrap mt-8">
            {etablissement?.equipes?.map((equipe) => (
              <div key={equipe.id} className="col-md-4 p-0 m-0 mt-8">
                <label className="d-flex align-items-center border-card mr-8">
                  <input
                    type="radio"
                    id={equipe.id}
                    name="equipe"
                    value={equipe.id}
                    checked={
                      selectedEmployee?.id === equipe?.id ||
                      employe?.selectedEmploye?.id === equipe?.id
                    }
                    onChange={() => handleEmployeeChange(equipe)}
                  />
                  <span className="custom-radio"></span> {equipe?.name}
                </label>
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
};
export default Employe;
